import(/* webpackMode: "eager" */ "/home/ubuntu/Profitonn-web-final/src/app/page.jsx");
